import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Mixpanel } from '../../../config/Mixpanel';
import Constants from '../../../common/constants';

const CertificateLoader = () => {
  const user_name = useSelector(store => store?.profileDetails?.name)
  const email = useSelector((store) => store?.profileDetails?.email);
  const phone_number = useSelector(
    (store) => store?.profileDetails?.["phone-number"]
  );
  const isPremium = useSelector(state => state?.onBoarding?.isPremium)
  const [visibleElements, setVisibleElements] = useState({
    title: false,
    flowItem1: false,
    flowItem2: false,
    flowItem3: false,
    globe: false,
    bottomText: false,
  });
  const selectedSkill = useSelector((store) => store?.onBoarding?.selectedSkill) || {};

  useEffect(() => {
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_CERTIFICATE_PAGE_LOADER_LOADED);
    Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_LOADER_LOADED);
  }, []);
  useEffect(() => {
    // Sequential animation timing
    const timers = {
      title: 200,
      flowItem1: 600,
      flowItem2: 1000,
      flowItem3: 1400,
      globe: 1800,
      bottomText: 2200,
    };

    Object.keys(timers).forEach((key) => {
      const timer = setTimeout(() => {
        setVisibleElements((prev) => ({ ...prev, [key]: true }));
      }, timers[key]);

      return () => clearTimeout(timer);
    });
  }, []);


  useEffect(() => {
    if(visibleElements.bottomText) {
      setTimeout(() => {
        window.location.href = `https://certified.learntube.ai/?skill_name=${selectedSkill?.['skill-name']}&isQuiz=true&user_name=${user_name}&email=${email}&phone_number=${phone_number}&utm_source=onboarding-flow&utm_medium=${isPremium ? 'premium-button' : 'free-button'}`;
      }, 2300);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleElements.bottomText]);

  return (
    <div className="mt-6 w-full flex flex-col items-center justify-start">
      {/* Title Section */}
      <div
        className={`text-center transition-all duration-700 ${
          visibleElements.title
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 -translate-y-8'
        }`}
      >
        <h1 className="text-[16px]  font-medium text-white">
          Preparing{' '}
          <span className="text-[#70AEFF] font-bold">10 Best Questions</span>...
        </h1>
      </div>

      {/* Arrow between Title and Flow Item 1 */}
      <div
        className={`mt-3 relative transition-all duration-700 ${
          visibleElements.title
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-8'
        }`}
        style={{ transitionDelay: '200ms' }}
      >
       <div className='w-[0.5px] h-[48px] bg-[#D5EDFF] relative opacity-60'>
        <div className='absolute bottom-0 -left-1 w-[8px] h-[8px] bg-[#D5EDFF] rounded-full'/>

       </div>
      </div>

      {/* Flowchart Section */}
      <div className="mt-3 flex flex-col items-center relative">
        {/* Flow Item 1 */}
        <div
          className={`relative flex items-center gap-3 transition-all duration-700 ${
            visibleElements.flowItem1
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
        >
          <FontAwesomeIcon icon={faCheck} className='text-[#406AFF]'/>
          <span className="font-medium text-[11px] text-[#D5EDFF]">
            Interview Questions from Top MNCs
          </span>
        </div>

        {/* Arrow between Item 1 and Item 2 */}
        <div
          className={`mt-3 relative transition-all duration-700 ${
            visibleElements.flowItem1
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '200ms' }}
        >
        <div className='w-[0.5px] h-[30px] bg-[#D5EDFF] relative opacity-60'>
        <div className='absolute bottom-0 -left-1 w-[8px] h-[8px] bg-[#D5EDFF] rounded-full'/>

       </div>
        </div>

        {/* Flow Item 2 */}
        <div
          className={`mt-3 relative flex items-center gap-3 transition-all duration-700 ${
            visibleElements.flowItem2
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
        >
          <FontAwesomeIcon icon={faCheck} className='text-[#406AFF]'/>
          <span className="font-medium text-[11px] text-[#D5EDFF]">
            Resumes from Successful Candidates
          </span>
        </div>

        {/* Arrow between Item 2 and Item 3 */}
        <div
          className={`mt-3 relative transition-all duration-700 ${
            visibleElements.flowItem2
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
          style={{ transitionDelay: '200ms' }}
        >
          <div className='w-[0.5px] h-[30px] bg-[#D5EDFF] relative opacity-60'>
        <div className='absolute bottom-0 -left-1 w-[8px] h-[8px] bg-[#D5EDFF] rounded-full'/>

       </div>
        </div>

        {/* Flow Item 3 */}
        <div
          className={`mt-3 relative flex flex-col items-center gap-2 transition-all duration-700 ${
            visibleElements.flowItem3
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="flex flex-col items-center text-center">
            <span className="text-white italic text-[12px]">
              Getting topics from
            </span>
            <span className="text-white text-[20px] font-bold">
              An Industry Expert...
            </span>
          </div>
        </div>
      </div>

      {/* Globe Section */}
      <div
        className={`mt-4 relative  transition-all md:w-[50%] duration-1000 ${
          visibleElements.globe
            ? 'opacity-100 scale-100'
            : 'opacity-0 scale-95'
        }`}
      >
       <img alt="" src="https://storage.googleapis.com/learntube-web-assets/files/OnBoardingPage/Frame%20427321261.webp" className='w-full'/>
      </div>

      {/* Bottom Text */}
      <div
        className={`absolute bottom-2 text-center transition-all duration-700 ${
          visibleElements.bottomText
            ? 'opacity-100 translate-y-0'
            : 'opacity-0 translate-y-8'
        }`}
      >
        <p className="text-white text-base md:text-lg">
          P.E.A.K.S. Assesses{' '}
          <span className="text-[#406AFF] font-semibold">
            Real Career Excellence
          </span>
        </p>
      </div>
    </div>
  );
};

export default CertificateLoader;

